import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

const OklchAura = definePreset(Aura, {
  primitive: {
    borderRadius: {
      none: '0',
      xs: 'var(--radius-xs)',
      sm: 'var(--radius-sm)',
      md: 'var(--radius-md)',
      lg: 'var(--radius-lg)',
      xl: 'var(--radius-xl)',
    },
    red: {
      50: 'var(--color-red-50)',
      100: 'var(--color-red-100)',
      200: 'var(--color-red-200)',
      300: 'var(--color-red-300)',
      400: 'var(--color-red-400)',
      500: 'var(--color-red-500)',
      600: 'var(--color-red-600)',
      700: 'var(--color-red-700)',
      800: 'var(--color-red-800)',
      900: 'var(--color-red-900)',
      950: 'var(--color-red-950)',
    },
    orange: {
      50: 'var(--color-orange-50)',
      100: 'var(--color-orange-100)',
      200: 'var(--color-orange-200)',
      300: 'var(--color-orange-300)',
      400: 'var(--color-orange-400)',
      500: 'var(--color-orange-500)',
      600: 'var(--color-orange-600)',
      700: 'var(--color-orange-700)',
      800: 'var(--color-orange-800)',
      900: 'var(--color-orange-900)',
      950: 'var(--color-orange-950)',
    },
    amber: {
      50: 'var(--color-amber-50)',
      100: 'var(--color-amber-100)',
      200: 'var(--color-amber-200)',
      300: 'var(--color-amber-300)',
      400: 'var(--color-amber-400)',
      500: 'var(--color-amber-500)',
      600: 'var(--color-amber-600)',
      700: 'var(--color-amber-700)',
      800: 'var(--color-amber-800)',
      900: 'var(--color-amber-900)',
      950: 'var(--color-amber-950)',
    },
    yellow: {
      50: 'var(--color-yellow-50)',
      100: 'var(--color-yellow-100)',
      200: 'var(--color-yellow-200)',
      300: 'var(--color-yellow-300)',
      400: 'var(--color-yellow-400)',
      500: 'var(--color-yellow-500)',
      600: 'var(--color-yellow-600)',
      700: 'var(--color-yellow-700)',
      800: 'var(--color-yellow-800)',
      900: 'var(--color-yellow-900)',
      950: 'var(--color-yellow-950)',
    },
    lime: {
      50: 'var(--color-lime-50)',
      100: 'var(--color-lime-100)',
      200: 'var(--color-lime-200)',
      300: 'var(--color-lime-300)',
      400: 'var(--color-lime-400)',
      500: 'var(--color-lime-500)',
      600: 'var(--color-lime-600)',
      700: 'var(--color-lime-700)',
      800: 'var(--color-lime-800)',
      900: 'var(--color-lime-900)',
      950: 'var(--color-lime-950)',
    },
    green: {
      50: 'var(--color-green-50)',
      100: 'var(--color-green-100)',
      200: 'var(--color-green-200)',
      300: 'var(--color-green-300)',
      400: 'var(--color-green-400)',
      500: 'var(--color-green-500)',
      600: 'var(--color-green-600)',
      700: 'var(--color-green-700)',
      800: 'var(--color-green-800)',
      900: 'var(--color-green-900)',
      950: 'var(--color-green-950)',
    },
    emerald: {
      50: 'var(--color-emerald-50)',
      100: 'var(--color-emerald-100)',
      200: 'var(--color-emerald-200)',
      300: 'var(--color-emerald-300)',
      400: 'var(--color-emerald-400)',
      500: 'var(--color-emerald-500)',
      600: 'var(--color-emerald-600)',
      700: 'var(--color-emerald-700)',
      800: 'var(--color-emerald-800)',
      900: 'var(--color-emerald-900)',
      950: 'var(--color-emerald-950)',
    },
    teal: {
      50: 'var(--color-teal-50)',
      100: 'var(--color-teal-100)',
      200: 'var(--color-teal-200)',
      300: 'var(--color-teal-300)',
      400: 'var(--color-teal-400)',
      500: 'var(--color-teal-500)',
      600: 'var(--color-teal-600)',
      700: 'var(--color-teal-700)',
      800: 'var(--color-teal-800)',
      900: 'var(--color-teal-900)',
      950: 'var(--color-teal-950)',
    },
    cyan: {
      50: 'var(--color-cyan-50)',
      100: 'var(--color-cyan-100)',
      200: 'var(--color-cyan-200)',
      300: 'var(--color-cyan-300)',
      400: 'var(--color-cyan-400)',
      500: 'var(--color-cyan-500)',
      600: 'var(--color-cyan-600)',
      700: 'var(--color-cyan-700)',
      800: 'var(--color-cyan-800)',
      900: 'var(--color-cyan-900)',
      950: 'var(--color-cyan-950)',
    },
    sky: {
      50: 'var(--color-sky-50)',
      100: 'var(--color-sky-100)',
      200: 'var(--color-sky-200)',
      300: 'var(--color-sky-300)',
      400: 'var(--color-sky-400)',
      500: 'var(--color-sky-500)',
      600: 'var(--color-sky-600)',
      700: 'var(--color-sky-700)',
      800: 'var(--color-sky-800)',
      900: 'var(--color-sky-900)',
      950: 'var(--color-sky-950)',
    },
    blue: {
      50: 'var(--color-blue-50)',
      100: 'var(--color-blue-100)',
      200: 'var(--color-blue-200)',
      300: 'var(--color-blue-300)',
      400: 'var(--color-blue-400)',
      500: 'var(--color-blue-500)',
      600: 'var(--color-blue-600)',
      700: 'var(--color-blue-700)',
      800: 'var(--color-blue-800)',
      900: 'var(--color-blue-900)',
      950: 'var(--color-blue-950)',
    },
    indigo: {
      50: 'var(--color-indigo-50)',
      100: 'var(--color-indigo-100)',
      200: 'var(--color-indigo-200)',
      300: 'var(--color-indigo-300)',
      400: 'var(--color-indigo-400)',
      500: 'var(--color-indigo-500)',
      600: 'var(--color-indigo-600)',
      700: 'var(--color-indigo-700)',
      800: 'var(--color-indigo-800)',
      900: 'var(--color-indigo-900)',
      950: 'var(--color-indigo-950)',
    },
    violet: {
      50: 'var(--color-violet-50)',
      100: 'var(--color-violet-100)',
      200: 'var(--color-violet-200)',
      300: 'var(--color-violet-300)',
      400: 'var(--color-violet-400)',
      500: 'var(--color-violet-500)',
      600: 'var(--color-violet-600)',
      700: 'var(--color-violet-700)',
      800: 'var(--color-violet-800)',
      900: 'var(--color-violet-900)',
      950: 'var(--color-violet-950)',
    },
    purple: {
      50: 'var(--color-purple-50)',
      100: 'var(--color-purple-100)',
      200: 'var(--color-purple-200)',
      300: 'var(--color-purple-300)',
      400: 'var(--color-purple-400)',
      500: 'var(--color-purple-500)',
      600: 'var(--color-purple-600)',
      700: 'var(--color-purple-700)',
      800: 'var(--color-purple-800)',
      900: 'var(--color-purple-900)',
      950: 'var(--color-purple-950)',
    },
    fuchsia: {
      50: 'var(--color-fuchsia-50)',
      100: 'var(--color-fuchsia-100)',
      200: 'var(--color-fuchsia-200)',
      300: 'var(--color-fuchsia-300)',
      400: 'var(--color-fuchsia-400)',
      500: 'var(--color-fuchsia-500)',
      600: 'var(--color-fuchsia-600)',
      700: 'var(--color-fuchsia-700)',
      800: 'var(--color-fuchsia-800)',
      900: 'var(--color-fuchsia-900)',
      950: 'var(--color-fuchsia-950)',
    },
    pink: {
      50: 'var(--color-pink-50)',
      100: 'var(--color-pink-100)',
      200: 'var(--color-pink-200)',
      300: 'var(--color-pink-300)',
      400: 'var(--color-pink-400)',
      500: 'var(--color-pink-500)',
      600: 'var(--color-pink-600)',
      700: 'var(--color-pink-700)',
      800: 'var(--color-pink-800)',
      900: 'var(--color-pink-900)',
      950: 'var(--color-pink-950)',
    },
    rose: {
      50: 'var(--color-rose-50)',
      100: 'var(--color-rose-100)',
      200: 'var(--color-rose-200)',
      300: 'var(--color-rose-300)',
      400: 'var(--color-rose-400)',
      500: 'var(--color-rose-500)',
      600: 'var(--color-rose-600)',
      700: 'var(--color-rose-700)',
      800: 'var(--color-rose-800)',
      900: 'var(--color-rose-900)',
      950: 'var(--color-rose-950)',
    },
    slate: {
      50: 'var(--color-slate-50)',
      100: 'var(--color-slate-100)',
      200: 'var(--color-slate-200)',
      300: 'var(--color-slate-300)',
      400: 'var(--color-slate-400)',
      500: 'var(--color-slate-500)',
      600: 'var(--color-slate-600)',
      700: 'var(--color-slate-700)',
      800: 'var(--color-slate-800)',
      900: 'var(--color-slate-900)',
      950: 'var(--color-slate-950)',
    },
    gray: {
      50: 'var(--color-gray-50)',
      100: 'var(--color-gray-100)',
      200: 'var(--color-gray-200)',
      300: 'var(--color-gray-300)',
      400: 'var(--color-gray-400)',
      500: 'var(--color-gray-500)',
      600: 'var(--color-gray-600)',
      700: 'var(--color-gray-700)',
      800: 'var(--color-gray-800)',
      900: 'var(--color-gray-900)',
      950: 'var(--color-gray-950)',
    },
    zinc: {
      50: 'var(--color-zinc-50)',
      100: 'var(--color-zinc-100)',
      200: 'var(--color-zinc-200)',
      300: 'var(--color-zinc-300)',
      400: 'var(--color-zinc-400)',
      500: 'var(--color-zinc-500)',
      600: 'var(--color-zinc-600)',
      700: 'var(--color-zinc-700)',
      800: 'var(--color-zinc-800)',
      900: 'var(--color-zinc-900)',
      950: 'var(--color-zinc-950)',
    },
    neutral: {
      50: 'var(--color-neutral-50)',
      100: 'var(--color-neutral-100)',
      200: 'var(--color-neutral-200)',
      300: 'var(--color-neutral-300)',
      400: 'var(--color-neutral-400)',
      500: 'var(--color-neutral-500)',
      600: 'var(--color-neutral-600)',
      700: 'var(--color-neutral-700)',
      800: 'var(--color-neutral-800)',
      900: 'var(--color-neutral-900)',
      950: 'var(--color-neutral-950)',
    },
    stone: {
      50: 'var(--color-stone-50)',
      100: 'var(--color-stone-100)',
      200: 'var(--color-stone-200)',
      300: 'var(--color-stone-300)',
      400: 'var(--color-stone-400)',
      500: 'var(--color-stone-500)',
      600: 'var(--color-stone-600)',
      700: 'var(--color-stone-700)',
      800: 'var(--color-stone-800)',
      900: 'var(--color-stone-900)',
      950: 'var(--color-stone-950)',
    },
  },
  semantic: {
    overlay: {
      select: {
        shadow: '0 4px 6px -1px oklch(0% 0 0 / 10%), 0 2px 4px -2px oklch(0% 0 0 / 10%)',
      },
      popover: {
        shadow: '0 4px 6px -1px oklch(0% 0 0 / 10%), 0 2px 4px -2px oklch(0% 0 0 / 10%)',
      },
      modal: {
        shadow: '0 20px 25px -5px oklch(0% 0 0 / 10%), 0 8px 10px -6px oklch(0% 0 0 / 10%)',
      },
      navigation: {
        shadow: '0 4px 6px -1px oklch(0% 0 0 / 10%), 0 2px 4px -2px oklch(0% 0 0 / 10%)',
      },
    },
    colorScheme: {
      dark: {
        highlight: {
          background: 'color-mix(in oklab, {primary.400} 16%, transparent)',
          focusBackground: 'color-mix(in oklab, {primary.400} 24%, transparent)',
          color: 'oklch(100% 0 0 / 87%)',
          focusColor: 'oklch(100% 0 0 / 87%)',
        },
        mask: {
          background: 'oklch(0% 0 0 / 60%)',
        },
        formField: {
          shadow: '0 0 oklch(0% 0 0 / 0%), 0 0 oklch(0% 0 0 / 0%), 0 1px 2px 0 oklch(0.18 0.0101 285.36 / 5%)',
        },
      },
    },
  },
  components: {
    button: {
      root: {
        raisedShadow: '0 3px 1px -2px oklch(0% 0 0 / 20%), 0 2px 2px 0 oklch(0% 0 0 / 14%), 0 1px 5px 0 oklch(0% 0 0 / 12%)',
      },
      colorScheme: {
        dark: {
          outlined: {
            primary: {
              hoverBackground: 'color-mix(in oklab, {primary.color} 4%, transparent)',
              activeBackground: 'color-mix(in oklab, {primary.color} 16%, transparent)',
            },
            secondary: {
              hoverBackground: 'oklch(100% 0 0 / 4%)',
              activeBackground: 'oklch(100% 0 0 / 16%)',
            },
            success: {
              hoverBackground: 'color-mix(in oklab, {green.400} 4%, transparent)',
              activeBackground: 'color-mix(in oklab, {green.400} 16%, transparent)',
            },
            info: {
              hoverBackground: 'color-mix(in oklab, {sky.400} 4%, transparent)',
              activeBackground: 'color-mix(in oklab, {sky.400} 16%, transparent)',
            },
            warn: {
              hoverBackground: 'color-mix(in oklab, {orange.400} 4%, transparent)',
              activeBackground: 'color-mix(in oklab, {orange.400} 16%, transparent)',
            },
            help: {
              hoverBackground: 'color-mix(in oklab, {purple.400} 4%, transparent)',
              activeBackground: 'color-mix(in oklab, {purple.400} 16%, transparent)',
            },
            danger: {
              hoverBackground: 'color-mix(in oklab, {red.400} 4%, transparent)',
              activeBackground: 'color-mix(in oklab, {red.400} 16%, transparent)',
            },
          },
          text: {
            primary: {
              hoverBackground: 'color-mix(in oklab, {primary.color} 4%, transparent)',
              activeBackground: 'color-mix(in oklab, {primary.color} 16%, transparent)',
            },
            success: {
              hoverBackground: 'color-mix(in oklab, {green.400} 4%, transparent)',
              activeBackground: 'color-mix(in oklab, {green.400} 16%, transparent)',
            },
            info: {
              hoverBackground: 'color-mix(in oklab, {sky.400} 4%, transparent)',
              activeBackground: 'color-mix(in oklab, {sky.400} 16%, transparent)',
            },
            warn: {
              hoverBackground: 'color-mix(in oklab, {orange.400} 4%, transparent)',
              activeBackground: 'color-mix(in oklab, {orange.400} 16%, transparent)',
            },
            help: {
              hoverBackground: 'color-mix(in oklab, {purple.400} 4%, transparent)',
              activeBackground: 'color-mix(in oklab, {purple.400} 16%, transparent)',
            },
            danger: {
              hoverBackground: 'color-mix(in oklab, {red.400} 4%, transparent)',
              activeBackground: 'color-mix(in oklab, {red.400} 16%, transparent)',
            },
          },
        },
      },
    },
    card: {
      root: {
        shadow: '0 1px 3px 0 oklch(0% 0 0 / 10%), 0 1px 2px -1px oklch(0% 0 0 / 10%)',
      },
    },
    chip: {
      colorScheme: {
        light: {
          root: {
            background: '{surface.100}',
            color: '{surface.800}',
          },
        },
        dark: {
          root: {
            background: 'oklch(100% 0 0 / 10%)',
            color: '{surface.0}',
          },
        },
      },
    },
    datatable: {
      headerCell:
      {
        selectedBackground: 'inherit',
        selectedColor: 'inherit',
      },
    },
    dock: {
      root: {
        background: 'oklch(100% 0 0 / 10%)',
        borderColor: 'oklch(100% 0 0 / 20%)',
      },
    },
    galleria: {
      navButton: {
        background: 'oklch(100% 0 0 / 10%)',
        hoverBackground: 'oklch(100% 0 0 / 20%)',
      },
      caption: {
        background: 'oklch(0% 0 0 / 50%)',
      },
      insetIndicatorList: {
        background: 'oklch(0% 0 0 / 50%)',
      },
      insetIndicatorButton: {
        background: 'oklch(100% 0 0 / 40%)',
        hoverBackground: 'oklch(100% 0 0 / 60%)',
        activeBackground: 'oklch(100% 0 0 / 90%)',
      },
      closeButton: {
        background: 'oklch(100% 0 0 / 10%)',
        hoverBackground: 'oklch(100% 0 0 / 20%)',
      },
    },
    image: {
      toolbar: {
        background: 'oklch(100% 0 0 / 10%)',
        borderColor: 'oklch(100% 0 0 / 20%)',
        position: {
          left: 'auto',
          right: '1rem',
          top: '3rem',
          bottom: 'auto',
        },
      },
      action: {
        hoverBackground: 'oklch(100% 0 0 / 10%)',
      },
    },
    imagecompare: {
      handle: {
        background: 'oklch(100% 0 0 / 30%)',
        hoverBackground: 'oklch(100% 0 0 / 30%)',
        focusRing: {
          color: 'oklch(100% 0 0 / 30%)',
        },
      },
    },
    inlinemessage: {
      colorScheme: {
        dark: {
          info: {
            background: 'color-mix(in oklab, {blue.500} 16%, transparent)',
            borderColor: 'color-mix(in oklab, {blue.700} 36%, transparent)',
            shadow: '0px 4px 8px 0px color-mix(in oklab, {blue.500} 4%, transparent)',
          },
          success: {
            background: 'color-mix(in oklab, {green.500} 16%, transparent)',
            borderColor: 'color-mix(in oklab, {green.700} 36%, transparent)',
            shadow: '0px 4px 8px 0px color-mix(in oklab, {green.500} 4%, transparent)',
          },
          warn: {
            background: 'color-mix(in oklab, {yellow.500} 16%, transparent)',
            borderColor: 'color-mix(in oklab, {yellow.700} 36%, transparent)',
            shadow: '0px 4px 8px 0px color-mix(in oklab, {yellow.500} 4%, transparent)',
          },
          error: {
            background: 'color-mix(in oklab, {red.500} 16%, transparent)',
            borderColor: 'color-mix(in oklab, {red.700} 36%, transparent)',
            shadow: '0px 4px 8px 0px color-mix(in oklab, {red.500} 4%, transparent)',
          },
          secondary: {
            shadow: '0px 4px 8px 0px color-mix(in oklab, {surface.500} 4%, transparent)',
          },
          contrast: {
            shadow: '0px 4px 8px 0px color-mix(in oklab, {surface.950} 4%, transparent)',
          },
        },
      },
    },
    message: {
      colorScheme: {
        dark: {
          info: {
            background: 'color-mix(in oklab, {blue.500} 16%, transparent)',
            borderColor: 'color-mix(in oklab, {blue.700} 36%, transparent)',
            shadow: '0px 4px 8px 0px color-mix(in oklab, {blue.500} 4%, transparent)',
            closeButton: {
              hoverBackground: 'oklch(100% 0 0 / 5%)',
            },
          },
          success: {
            background: 'color-mix(in oklab, {green.500} 16%, transparent)',
            borderColor: 'color-mix(in oklab, {green.700} 36%, transparent)',
            shadow: '0px 4px 8px 0px color-mix(in oklab, {green.500} 4%, transparent)',
            closeButton: {
              hoverBackground: 'oklch(100% 0 0 / 5%)',
            },
          },
          warn: {
            background: 'color-mix(in oklab, {yellow.500} 16%, transparent)',
            borderColor: 'color-mix(in oklab, {yellow.700} 36%, transparent)',
            shadow: '0px 4px 8px 0px color-mix(in oklab, {yellow.500} 4%, transparent)',
            closeButton: {
              hoverBackground: 'oklch(100% 0 0 / 5%)',
            },
          },
          error: {
            background: 'color-mix(in oklab, {red.500} 16%, transparent)',
            borderColor: 'color-mix(in oklab, {red.700} 36%, transparent)',
            shadow: '0px 4px 8px 0px color-mix(in oklab, {red.500} 4%, transparent)',
            closeButton: {
              hoverBackground: 'oklch(100% 0 0 / 5%)',
            },
          },
          secondary: {
            shadow: '0px 4px 8px 0px color-mix(in oklab, {surface.500} 4%, transparent)',
          },
          contrast: {
            shadow: '0px 4px 8px 0px color-mix(in oklab, {surface.950} 4%, transparent)',
          },
        },
      },
    },
    ripple: {
      colorScheme: {
        dark: {
          root: {
            background: 'oklch(100% 0 0 / 30%)',
          },
        },
      },
    },
    skeleton: {
      colorScheme: {
        dark: {
          root: {
            background: 'oklch(100% 0 0 / 6%)',
            animationBackground: 'oklch(100% 0 0 / 4%)',
          },
        },
      },
    },
    slider: {
      handle: {
        content: {
          shadow: '0px 0.5px 0px 0px oklch(0% 0 0 / 8%), 0px 1px 1px 0px oklch(0% 0 0 / 14%)',
        },
      },
    },
    splitbutton: {
      root: {
        raisedShadow: '0 3px 1px -2px oklch(0% 0 0 / 20%), 0 2px 2px 0 oklch(0% 0 0 / 14%), 0 1px 5px 0 oklch(0% 0 0 / 12%)',
      },
    },
    stepper: {
      stepNumber: {
        shadow: '0px 0.5px 0px 0px oklch(0% 0 0 / 6%), 0px 1px 1px 0px oklch(0% 0 0 / 12%)',
      },
    },
    steps: {
      itemNumber: {
        shadow: '0px 0.5px 0px 0px oklch(0% 0 0 / 6%), 0px 1px 1px 0px oklch(0% 0 0 / 12%)',
      },
    },
    tabs: {
      colorScheme: {
        dark: {
          navButton: {
            shadow: '0px 0px 10px 50px color-mix(in oklab, {content.background} 50%, transparent)',
          },
        },
      },
    },
    tabview: {
      colorScheme: {
        dark: {
          navButton: {
            shadow: '0px 0px 10px 50px color-mix(in oklab, {content.background} 50%, transparent)',
          },
        },
      },
    },
    tag: {
      colorScheme: {
        dark: {
          primary: {
            background: 'color-mix(in oklab, {primary.500} 16%, transparent)',
          },
          success: {
            background: 'color-mix(in oklab, {green.500} 16%, transparent)',
          },
          info: {
            background: 'color-mix(in oklab, {sky.500} 16%, transparent)',
          },
          warn: {
            background: 'color-mix(in oklab, {orange.500} 16%, transparent)',
          },
          danger: {
            background: 'color-mix(in oklab, {red.500} 16%, transparent)',
          },
        },
      },
    },
    timeline: {
      eventMarker: {
        content: {
          insetShadow: '0px 0.5px 0px 0px oklch(0% 0 0 / 6%), 0px 1px 1px 0px oklch(0% 0 0 / 12%)',
        },
      },
    },
    toast: {
      colorScheme: {
        dark: {
          info: {
            background: 'color-mix(in oklab, {blue.500} 16%, transparent)',
            borderColor: 'color-mix(in oklab, {blue.700} 36%, transparent)',
            shadow: '0px 4px 8px 0px color-mix(in oklab, {blue.500} 4%, transparent)',
            closeButton: {
              hoverBackground: 'oklch(100% 0 0 / 5%)',
            },
          },
          success: {
            background: 'color-mix(in oklab, {green.500} 16%, transparent)',
            borderColor: 'color-mix(in oklab, {green.700} 36%, transparent)',
            shadow: '0px 4px 8px 0px color-mix(in oklab, {green.500} 4%, transparent)',
            closeButton: {
              hoverBackground: 'oklch(100% 0 0 / 5%)',
            },
          },
          warn: {
            background: 'color-mix(in oklab, {yellow.500} 16%, transparent)',
            borderColor: 'color-mix(in oklab, {yellow.700} 36%, transparent)',
            shadow: '0px 4px 8px 0px color-mix(in oklab, {yellow.500} 4%, transparent)',
            closeButton: {
              hoverBackground: 'oklch(100% 0 0 / 5%)',
            },
          },
          error: {
            background: 'color-mix(in oklab, {red.500} 16%, transparent)',
            borderColor: 'color-mix(in oklab, {red.700} 36%, transparent)',
            shadow: '0px 4px 8px 0px color-mix(in oklab, {red.500} 4%, transparent)',
            closeButton: {
              hoverBackground: 'oklch(100% 0 0 / 5%)',
            },
          },
          secondary: {
            shadow: '0px 4px 8px 0px color-mix(in oklab, {surface.500} 4%, transparent)',
          },
          contrast: {
            shadow: '0px 4px 8px 0px color-mix(in oklab, {surface.950} 4%, transparent)',
          },
        },
      },
    },
    togglebutton: {
      content: {
        checkedShadow: '0px 1px 2px 0px oklch(0% 0 0 / 2%), 0px 1px 2px 0px oklch(0% 0 0 / 4%)',
      },
    },
    tooltip: {
      colorScheme: {
        dark: {
          root: {
            background: '{surface.600}',
          },
        },
      },
    },
  },
});

const MiraclePreset = definePreset(OklchAura, {
  semantic: {
    primary: {
      50: 'oklch(0.966 0.014 39.5)',
      100: 'oklch(0.934 0.03 38.59)',
      200: 'oklch(0.867 0.063 39.25)',
      300: 'oklch(0.795 0.109 43.86)',
      400: 'oklch(0.731 0.159 50.26)',
      500: 'oklch(0.633 0.137 50.69)',
      600: 'oklch(0.535 0.117 49.93)',
      700: 'oklch(0.439 0.096 49.85)',
      800: 'oklch(0.334 0.072 50.97)',
      900: 'oklch(0.236 0.051 49.57)',
      950: 'oklch(0.193 0.042 50.32)',
    },
    colorScheme: {
      light: {
        surface: {
          50: '{neutral.50}',
          100: '{neutral.100}',
          200: '{neutral.200}',
          300: '{neutral.300}',
          400: '{neutral.400}',
          500: '{neutral.500}',
          600: '{neutral.600}',
          700: '{neutral.700}',
          800: '{neutral.800}',
          900: '{neutral.900}',
          950: '{neutral.950}',
        },
      },
    },
    formField: {
      paddingX: '0.5rem',
      paddingY: '0.25rem',
      borderRadius: '{borderRadius.sm}',
    },
  },
  components: {
    accordion: {
      header: {
        padding: '1rem',
      },
      content: {
        padding: '1rem',
      },
    },
    carousel: {
      colorScheme: {
        light: {
          indicator: {
            background: '{surface.500}',
          },
        },
      },
    },
    datatable: {
      headerCell: {
        background: '{blue.100}',
        padding: '0.5rem 0.75rem',
      },
      row: {
        background: '{surface.50}',
      },
      bodyCell: {
        padding: '0.5rem 0.75rem',
      },
    },
    datepicker: {
      dropdown: {
        width: '2rem',
      },
    },
    progressbar: {
      root: {
        height: '0.5rem',
      },
    },
    scrollpanel: {
      colorScheme: {
        light: {
          bar: {
            background: '{surface.200}',
          },
        },
      },
    },
    select: {
      dropdown: {
        width: '2rem',
      },
    },
    tag: {
      colorScheme: {
        light: {
          warn: {
            background: '{amber.100}',
            color: '{amber.700}',
          },
        },
      },
    },
    toast: {
      root: {
        width: '20rem',
      },
      icon: {
        size: '1.4rem',
      },
    },
    toggleswitch: {
      root: {
        width: '3.5rem',
      },
      handle: {
        size: '1.5rem',
      },
    },
    tooltip: {
      root: {
        gutter: '0.3rem',
      },
    },
  },
});

export default MiraclePreset;
